var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-modal",
    { attrs: { value: "" } },
    [
      _vm.step == 0
        ? _c(
            "w-card",
            { attrs: { "max-width": "500" } },
            [
              _c("w-card-title", [
                _vm._v(_vm._s(_vm.$ct("share-views-select-views"))),
              ]),
              _c(
                "w-scroll-view",
                { attrs: { tag: "w-card-content" } },
                _vm._l(_vm.browses, function (browse) {
                  return _c(
                    "w-row",
                    { key: browse.ID },
                    [
                      _c(
                        "w-col",
                        { attrs: { xs: "12" } },
                        [
                          _c("app-browse", {
                            attrs: {
                              browse: browse,
                              "selected-views": _vm.selectedViews,
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                }),
                1
              ),
              _c(
                "w-card-actions",
                [
                  _c(
                    "w-button",
                    {
                      staticClass: "cancel",
                      attrs: { icon: "ban" },
                      on: {
                        click: function ($event) {
                          return _vm.close()
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$ct("common.cancel")))]
                  ),
                  _c("w-spacer"),
                  _c(
                    "w-button",
                    {
                      attrs: {
                        disabled: _vm.selectedViews.length == 0,
                        icon: "arrow-right",
                      },
                      on: {
                        click: function ($event) {
                          _vm.step = 1
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$ct("common.next")))]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.step == 1
        ? _c(
            "w-card",
            { attrs: { "max-width": "500" } },
            [
              _c("w-card-title", [
                _vm._v(_vm._s(_vm.$ct("share-views-select-users"))),
              ]),
              _c(
                "w-scroll-view",
                { attrs: { tag: "w-card-content" } },
                _vm._l(_vm.users, function (user) {
                  return _c(
                    "w-row",
                    { key: user.ID },
                    [
                      _c(
                        "w-col",
                        { attrs: { xs: "12" } },
                        [
                          _c("w-checkbox", {
                            attrs: { label: user.getShortDisplayName() },
                            on: {
                              input: function ($event) {
                                return _vm.selectUser(user, $event)
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                }),
                1
              ),
              _c(
                "w-card-actions",
                [
                  _c(
                    "w-button",
                    {
                      staticClass: "cancel",
                      attrs: { icon: "arrow-left", disabled: _vm.saving },
                      on: {
                        click: function ($event) {
                          return _vm.close()
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$ct("common.back")))]
                  ),
                  _c("w-spacer"),
                  _c(
                    "w-button",
                    {
                      attrs: {
                        icon: "check",
                        disabled: _vm.saving || _vm.selectedUsers.length == 0,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.confirm()
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$ct("common.confirm")))]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }